import { copy } from '../content/copy';
import { Pill } from '../components/Pill';
import { SectionLabel } from '../components/SectionLabel';

export function Cases() {
  const { cases } = copy;
  return (
    <section id="cases" className="bg-l-paper-soft bg-math-pattern px-6 md:px-10 py-20 md:py-28">
      <div className="mx-auto max-w-[1120px]">
        <SectionLabel>РАЗДЕЛ 04 · РЕЗУЛЬТАТЫ</SectionLabel>
        <h2 className="font-display font-medium text-l-ink-deep text-[32px] md:text-[40px] leading-[1.15] tracking-[-0.02em] mb-12">
          {cases.title}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-10">
          {cases.items.map((c, i) => (
            <article key={c.headline} className="pt-6 border-t border-l-rule">
              <div className="flex items-baseline gap-4">
                <span className="font-display text-l-terracotta text-5xl md:text-6xl tabular-nums leading-none">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <div>
                  {c.tags.length > 0 && (
                    <div className="flex gap-2 mb-2 flex-wrap">
                      {c.tags.map((t) => <Pill key={t}>{t}</Pill>)}
                    </div>
                  )}
                  <h3 className="font-display text-l-ink-deep text-xl md:text-2xl mb-2 leading-[1.25]">
                    {c.headline}
                  </h3>
                  <p className="font-sans text-l-ink text-[15px] leading-[1.6]">{c.detail}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
        <p className="mt-14 font-display italic text-l-marginalia text-base">
          {cases.reviewsCaption}
        </p>
        {/* TODO: плитка скринов отзывов — заполнит Маша в public/landing/reviews/ */}
      </div>
    </section>
  );
}
